IREP.FilterList = (function () {
    var init = function () {

    };

    $("#CategoryId").change(function () {
        $("form").submit();
    });

    $(".filtername").click(function () {
        if ($(this).parent().attr("data-filterid") > 0) {
            //show filter editor
            $(".listLoadingWrapper").show();
            IREP.callApi("Filters/GetAllFiltersForEdit",
                "GET",
                {
                    FilterId: $(this).parent().attr("data-filterid"),
                    CategoryId: $(this).parent().attr("data-categoryid")
                }).done(function (data) {
                    var filter = data.filters[0].filter;
                    $("#CategoryNameField").html(filter.categoryLocaleText);
                    $("#txtCategoryName").val(filter.categoryLocaleText);
                    $("#EditCategoryId").val(filter.categoryId);
                    $("#txtCategoryLocaleTextId").val(filter.categoryLocaleTextId);
                    $("#txtFilterName").val(filter.filterLocaleText);
                    $("#txtFilterLocaleTextId").val(filter.filterLocaleTextId);
                    $("#FilterEditorWrapper").show();
                    translateId(IREP.options.user.cultureCode, filter.filterLocaleTextId, $("#FilterLocaleTextName"));
                    $("#saveFilter").attr("data-filterid", filter.filterId);
                    $("#CategoryName").show();
                    $("#CategorySelect").hide();
                    $("#CategoryEdit").hide();
                    $("#FilterName").show();
                    $(".listLoadingWrapper").hide();
                });
        }
    });

    $(".ativities").click(function () {
        $(".listLoadingWrapper").show();
        var filtername = $(this).parent().find(".filtername").html();
        var isAdmin = $("#isTagAdmin").val();
        $(".filterActivityRow").remove();
        if ($(this).parent().attr("data-filterid") > 0) {
            $("#addActivityBtn").attr("data-filterid", $(this).parent().attr("data-filterid"));
            $("#addToolBtn").attr("data-filterid", $(this).parent().attr("data-filterid"));
            //show filter editor
            IREP.callApi("filters/getObjectsByFilterId",
                "GET",
                {
                    FilterId: $(this).parent().attr("data-filterid")
                }).done(function (data) {
                    console.log(data);
                    $.each(data.activities, function (index, value) {
                        $("#filterActivityList").append("<div class='filterActivityRow' data-filterCollectionId='" + value.filterCollectionId + "'>" + (isAdmin ? "<div  class='deleteColumn'>X</div>" : "") + "<div class='filterActivity'>" + value.name + "<br/>" + value.activityCode + "</div>" + (isAdmin ? "<div class='weightColumn'>" + value.weight + "</div>" : "") + "</div>");
                    });
                    $.each(data.tools, function (index, value) {
                        $("#filterToolList").append("<div class='filterActivityRow' data-filterCollectionId='" + value.filterCollectionId + "'>" + (isAdmin ? "<div  class='deleteColumn'>X</div>" : "") + "<div class='filterActivity'>" + value.name + "<br/>" + value.toolCode + "</div>" + (isAdmin ? "<div class='weightColumn'>" + value.weight + "</div>" : "") + "</div>" );
                    });
                    $(".filterTitle").html(filtername + " <span style='font-size:10px;'>(click to edit filters)</span>");
                    $("#filterActivityTab").click();
                    $("#FilterActivitiesWrapper").show();
                    $(".listLoadingWrapper").hide();
                });
           
        }
    });

    $("#EditCategoryId").change(function(){
        $("#CategoryNameField").html($("#EditCategoryId option:selected").text());
        $("#txtCategoryName").val($("#EditCategoryId option:selected").text());
        $("#txtCategoryLocaleTextId").val($("#EditCategoryId option:selected").attr("data-localetextid"));
    });

    $("#saveFilter").click(function () {
        $(".listLoadingWrapper").show();
        IREP.callApi("Filters/UpdateFilter",
            "POST",
            {
                FilterLocaleTextId:$("#txtFilterLocaleTextId").val(),
                FilterName:$("#txtFilterName").val(),
                FilterId: $("#saveFilter").attr("data-filterid"),
                CategoryId:$("#EditCategoryId").val(),
                CategoryName: $("#txtCategoryName").val(),
                CategoryLocaleTextId:$("#txtCategoryLocaleTextId").val()
            }
        ).done(function () {
            window.location = window.location;
        });
    });

    $("#filterActivityTab").click(function () {
       $(".filterTabs").removeClass("selected");
       $(this).addClass("selected");
       $("#FilterActivities").show();
       $("#filterTools").hide();
    });


    $("#filterToolTab").click(function () {
        $(".filterTabs").removeClass("selected");
        $(this).addClass("selected");
        $("#FilterActivities").hide();
        $("#filterTools").show();
    });

    $("#filterTab").click(function () {
        $(".newFilterTab").removeClass("selected");
        $(this).addClass("selected");
        $("#newFilterEdit").show();
        $("#newCategoryEdit").hide();
    });


    $("#categoryTab").click(function () {
        $(".newFilterTab").removeClass("selected");
        $(this).addClass("selected");
        $("#newFilterEdit").hide();
        $("#newCategoryEdit").show();
    });

    $("#txtCategoryLocaleTextId").keyup(function () {
        translateId($("#CategoryCultureCode").val(), $(this).val(), $("#CategoryLocaleTextName"));
    });

    $("#CategoryCultureCode").change(function () {
        translateId($(this).val(), $("#txtCategoryLocaleTextId").val(), $("#CategoryLocaleTextName"));
    });

    $("#txtFilterLocaleTextId").keyup(function () {
        translateId($("#FilterCultureCode").val(), $(this).val(), $("#FilterLocaleTextName"));
    });

    $("#FilterCultureCode").change(function () {
        translateId($(this).val(), $("#txtFilterLocaleTextId").val(), $("#FilterLocaleTextName"));
    });

    $("#txtNewCategoryLocaleTextId").keyup(function () {
        translateId($("#NewCategoryCultureCode").val(), $(this).val(), $("#NewCategoryLocaleTextName"));
    });

    $("#NewCategoryCultureCode").change(function () {
        translateId($(this).val(), $("#txtNewCategoryLocaleTextId").val(), $("#NewCategoryLocaleTextName"));
    });

    $("#txtNewFilterLocaleTextId").keyup(function () {
        translateId($("#NewFilterCultureCode").val(), $(this).val(), $("#NewFilterLocaleTextName"));
    });

    $("#NewFilterCultureCode").change(function () {
        translateId($(this).val(), $("#NewtxtFilterLocaleTextId").val(), $("#NewFilterLocaleTextName"));
    });

    var translateId = function (culture, id, textBox) {
        IREP.callApi("localization/text",
                "GET",
                {
                    cultureCode: culture,
                    Id: id
                }).done(function (data) {
                    if (data.text) {
                        var dispText = data.text.length > 200 ? data.text.substring(0, 200) + "..." : data.text;
                        textBox.html(dispText);
                        textBox.attr("title", data.text);
                    } else {
                        textBox.html("Not translated");
                        textBox.attr("title", "");
                    }
                });
    }

    $(document).on("click", ".filterActivity", function () {
        $(".listLoadingWrapper").show();
        var url = IREP.generateSiteLink("/editor/filters/" + $(this).parent().attr("data-filterCollectionId"));
        $("#tagEditor").load(url, function () { $("#FilterActivitiesWrapper").hide(); $("#tagEditorWrapper").show(); $(".listLoadingWrapper").hide(); });
        
    });

    $("#addActivityBtn").click(function () {
        $(".listLoadingWrapper").show();
        var filterId = $("#addActivityBtn").attr("data-filterid");
        // lookup the filtercollectionid
        IREP.callApi("/activity/GetActivitiesForEdit",
            "GET",
            {
                    CountryCode : IREP.options.user.countryCode,
                    SiteCollection : IREP.options.user.siteCollection,
                    CultureCode : IREP.options.user.cultureCode,
                    ActCode : $("#addActivityToFilter").val()
            }
            ).done(function (actData) {
                
                if (actData.activities.length == 1) {
                    var activity = actData.activities[0];
                    
                    if (activity.filterCollectionId > -1) {
                        var url = IREP.generateSiteLink("/editor/filters/" + activity.filterCollectionId + "/" + IREP.options.user.site + "/" + filterId);
                        $("#tagEditor").load(url, function () { $("#FilterActivitiesWrapper").hide(); $("#tagEditorWrapper").show(); $(".listLoadingWrapper").hide(); });
                    } else {
                        IREP.callApi("Filters/NewFilterCollection",
                                    "POST",
                                    {
                                        filterType: 'activity',
                                        id: activity.activityId
                                    }).done(function (data) {
                                        var url = IREP.generateSiteLink("/editor/filters/" + data.filterCollectionId + "/" + IREP.options.user.site + "/" + filterId);
                                        $("#tagEditor").load(url, function () { $("#FilterActivitiesWrapper").hide(); $("#tagEditorWrapper").show(); $(".listLoadingWrapper").hide(); });
                                    });
                    }
                } else {
                    alert("Please enter an ACTUAL activity code... j/k...");
                }
        });
    });

    $("#addToolBtn").click(function () {
        $(".listLoadingWrapper").show();
        var filterId = $("#addToolBtn").attr("data-filterid");
        // lookup the filtercollectionid
        IREP.callApi("/tools/alltoolsdata",
            "GET",
            {
                Active: false,
                GeoCode: IREP.options.user.siteCollection,
                ToolCode: $("#addToolToFilter").val()
            }
            ).done(function (actData) {
                if (actData.data.length == 1) {
                    var tool = actData.data[0];

                    if (tool.filterCollectionId > -1) {
                        var url = IREP.generateSiteLink("/editor/filters/" + tool.filterCollectionId + "/" + IREP.options.user.site + "/" + filterId);
                        $("#tagEditor").load(url, function () { $("#FilterActivitiesWrapper").hide(); $("#tagEditorWrapper").show(); $(".listLoadingWrapper").hide(); });
                    } else {
                        IREP.callApi("Filters/NewFilterCollection",
                                    "POST",
                                    {
                                        filterType: 'tool',
                                        id: tool.toolid
                                    }).done(function (data) {
                                        
                                        var url = IREP.generateSiteLink("/editor/filters/" + data.filterCollectionId + "/" + IREP.options.user.site + "/" + filterId);
                                        $("#tagEditor").load(url, function () { $("#FilterActivitiesWrapper").hide(); $("#tagEditorWrapper").show(); $(".listLoadingWrapper").hide(); });
                                    });
                    }
                } else {
                    alert("Please enter an ACTUAL tool code... j/k...");
                }
            });
    });

    $("#changeCategory").click(function () {
        $("#CategoryName").hide();
        $("#CategorySelect").show();
        $("#CategoryEdit").hide();
        $("#FilterName").show();
    });

    $("#editCategory").click(function () {
        $("#CategoryName").hide();
        $("#CategorySelect").hide();
        $("#CategoryEdit").show();
        $("#FilterName").hide();
        translateId(IREP.options.user.cultureCode, $("#txtCategoryLocaleTextId").val(), $("#CategoryLocaleTextName"));
    });

    $("#closeCategory").click(function () {
        $("#CategoryName").show();
        $("#CategorySelect").hide();
        $("#CategoryEdit").hide();
        $("#FilterName").show();
    });

    $("#closeFiltersBtn").click(function () {
        $("#FilterEditorWrapper").hide();
        $("#CategoryName").show();
        $("#CategorySelect").hide();
        $("#CategoryEdit").hide();
        $("#FilterName").show();
    });

    $("#closeFilterActiviesBtn").click(function () {
        $("#FilterActivitiesWrapper").hide();
    });

    $("#closeActivityFiltersBtn").click(function () {
        $("#tagEditorWrapper").hide();
    });

    $("#closeNewFilterBtn").click(function () {
        $("#NewFilterWrapper").hide();
    });

    $(".focusAndBlur").focus(function () {
        if ($(this).val() === $(this).attr("data-defaultvalue")) {
            $(this).val("");
            $(this).addClass("focused");
        } 
    }).blur(function () {        
        if ($(this).val() === "") {
            $(this).val($(this).attr("data-defaultvalue"));
            $(this).removeClass("focused");
        }
    });

    $("#btnAddNew").click(function () {
        $("#NewFilterWrapper").show();
    });

    $("#newFilter").click(function () {
        if ($("#newFilterEdit").is(":visible") == true) {
            IREP.callApi("filters/addNewFilter",
               "POST",
               {
                    FilterLocaleTextId : $("#txtNewFilterLocaleTextId").val(), 
                    FilterName : $("#txtNewFilterName").val(),
                    CategoryId : $("#newFilterCategoryId").val()
            }).done(function (actData) {
                   window.location = window.location;
            });
        } else {
            IREP.callApi("filters/addNewCategory",
               "POST",
               {
                   CategoryName : $("#txtNewCategoryName").val(),
                   CategoryLocaleTextId: $("#txtNewCategoryLocaleTextId").val()
               }).done(function (actData) {

                   window.location = window.location;
               });
        }
    });

    $(document).on("click", ".deleteColumn", function () {
        var filColId = $(this).parent().attr("data-filtercollectionid");
        var filId = $("#addToolBtn").attr("data-filterid");
        console.log(filColId, filId);
        IREP.callApi("Filters/RemoveFilter",
               "POST",
               {
                   FilterCollectionId: filColId,
                   FilterId : filId
               }).done(function (actData) {
                   window.location = window.location;
               });
    });

    return {
        init: init
    };
})();